function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".smartDoor-icon{fill:url(#smartDoor);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "smartDoor",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00008B"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M24.2,72.1c-0.3,0-0.6-0.1-0.8-0.3L10.8,61.1c-0.3-0.2-0.4-0.6-0.4-0.9c0-0.4,0.2-0.7,0.4-0.9l12.6-10.6    c0.4-0.3,0.9-0.4,1.3-0.2c0.4,0.2,0.7,0.6,0.7,1.1v5.3h4.3c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2h-5.5    c-0.7,0-1.2-0.5-1.2-1.2v-3.9l-9.5,8l9.5,8v-3.9c0-0.7,0.5-1.2,1.2-1.2h5.5c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.5,1.2-1.2,1.2h-4.3v5.3    c0,0.5-0.3,0.9-0.7,1.1C24.5,72,24.3,72.1,24.2,72.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M24.3,46.6c-0.7,0-1.2-0.5-1.2-1.2V11.8c0-0.7,0.5-1.2,1.2-1.2h23c0.7,0,1.2,0.5,1.2,1.2    c0,0.7-0.5,1.2-1.2,1.2H25.5v32.4C25.5,46.1,24.9,46.6,24.3,46.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M33.9,92.3h-9.7c-0.7,0-1.2-0.5-1.2-1.2V75.3c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2v14.6h8.5    c0.7,0,1.2,0.5,1.2,1.2C35.2,91.8,34.6,92.3,33.9,92.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M68.4,92.3c-0.7,0-1.2-0.5-1.2-1.2V35.8c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2v55.3    C69.6,91.8,69.1,92.3,68.4,92.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M33.9,100c-0.3,0-0.5-0.1-0.8-0.3c-0.3-0.2-0.5-0.6-0.5-0.9V19.7c0-0.6,0.4-1.1,0.9-1.2L55,13.7    c0.7-0.1,1.3,0.3,1.5,0.9c0.1,0.7-0.3,1.3-0.9,1.5l-20.4,4.6v76.6l33-7.3c0.7-0.1,1.3,0.3,1.5,0.9c0.1,0.7-0.3,1.3-0.9,1.5    L34.2,100C34.1,100,34,100,33.9,100z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "smartDoor-icon",
  cx: 43.9,
  cy: 58.2,
  r: 2.1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M88.4,11.7c-0.6,0-1.1-0.4-1.2-1c-0.4-2.1-1.5-3.9-3-5.4c-1.5-1.5-3.4-2.5-5.4-3        c-0.7-0.1-1.1-0.8-0.9-1.4c0.1-0.7,0.8-1.1,1.4-0.9c2.5,0.5,4.8,1.8,6.6,3.6c1.8,1.8,3.1,4.1,3.6,6.6c0.1,0.7-0.3,1.3-0.9,1.4        C88.6,11.7,88.5,11.7,88.4,11.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M83.1,11.5c-0.6,0-1.1-0.4-1.2-1c-0.2-0.7-0.5-1.3-1-1.8c-0.5-0.5-1.1-0.9-1.8-1        c-0.7-0.1-1.1-0.8-0.9-1.4c0.1-0.7,0.8-1.1,1.4-0.9c1.2,0.3,2.2,0.8,3,1.7c0.8,0.8,1.4,1.9,1.7,3c0.1,0.7-0.3,1.3-0.9,1.4        C83.3,11.5,83.2,11.5,83.1,11.5z"
})))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M68.4,37c-8.7,0-15.8-7.1-15.8-15.8S59.7,5.4,68.4,5.4c8.7,0,15.8,7.1,15.8,15.8S77.1,37,68.4,37z     M68.4,7.9C61,7.9,55,13.9,55,21.2s6,13.4,13.4,13.4c7.4,0,13.4-6,13.4-13.4S75.8,7.9,68.4,7.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M68.4,22.2c-0.7,0-1.2-0.5-1.2-1.2v-5.4c0-0.7,0.5-1.2,1.2-1.2c0.7,0,1.2,0.5,1.2,1.2V21    C69.6,21.6,69.1,22.2,68.4,22.2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "smartDoor-icon",
  d: "M68.4,28.5c-3.5,0-6.4-2.9-6.4-6.4c0-1.9,0.8-3.6,2.2-4.9c0.5-0.4,1.3-0.4,1.7,0.1    c0.4,0.5,0.4,1.3-0.1,1.7c-0.9,0.8-1.4,1.9-1.4,3c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4c0-1.1-0.5-2.2-1.3-2.9    c-0.5-0.5-0.5-1.2-0.1-1.7c0.5-0.5,1.2-0.5,1.7-0.1c1.3,1.2,2.1,2.9,2.1,4.7C74.8,25.6,71.9,28.5,68.4,28.5z"
})));

function SvgSmartDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDoor);
export default __webpack_public_path__ + "static/media/smartDoor.86c7d18f.svg";
export { ForwardRef as ReactComponent };